export const FETCH_CARPENTERS_SUCCESS = "FETCH_CARPENTERS_SUCCESS";
export const POST_CARPENTERS_SUCCESS = "POST_CARPENTERS_SUCCESS";
export const GET_LIST_DETAIL_SUCCESS = "GET_LIST_DETAIL_SUCCESS";
export const PUT_CARPENTERS_SUCCESS = "PUT_CARPENTERS_SUCCESS";
export const DELETE_CARPENTERS_SUCCESS = "DELETE_CARPENTERS_SUCCESS";
export const MOUNT_SUPPLIER_STAFF_PASSWORD_DIALOG_SUCCESS = "MOUNT_SUPPLIER_STAFF_PASSWORD_DIALOG_SUCCESS";
export const PUT_SUPPLIER_STAFF_PASSWORD_SUCCESS =
  "PUT_SUPPLIER_STAFF_PASSWORD_SUCCESS";
